import { render, staticRenderFns } from "./MergeSection.vue?vue&type=template&id=6807f8d0&scoped=true&"
import script from "./MergeSection.vue?vue&type=script&lang=js&"
export * from "./MergeSection.vue?vue&type=script&lang=js&"
import style0 from "./MergeSection.vue?vue&type=style&index=0&id=6807f8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807f8d0",
  null
  
)

export default component.exports